<template>
  <div class="lineupcard" @click="cardclick">
    <div class="card-img">
      <img
        v-if="list.headimg"
        :src="'images/' + list.id + '/gal/' + list.headimg"
      />
      <img v-else :src="'images/' + list.id + '/' + list.mainimg" />
    </div>
    <div class="card-tx">
      <h3>{{ name }}</h3>
      <h4 class="maincopy">{{ list.maincopy }}</h4>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  setup() {},
  components: {},
  props: ["id", "locate", "name"],
  computed: {
    list() {
      let list = this.$alllist[this.locate][this.id];
      return list;
    },
  },
  methods: {
    cardclick() {
      this.$emit("cardclick", {
        state: true,
        target: this.list,
        name: this.name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lineupcard {
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: 0.25s ease-in-out;
  &:hover {
    transform: translateY(-0.5rem);
    .card-img {
      img {
        transform: scale(1.05);
      }
    }
  }
  .card-img {
    width: 100%;
    height: auto;
    aspect-ratio: 3/2;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      transition: 0.25s ease-in-out;
    }
  }
  .card-tx {
    background-color: white;
    padding: 1em;
    position: relative;
    .vr-icon {
      position: absolute;
      right: 0;
      top: -1rem;
      margin: 0 0.5rem;
      width: clamp(36px, 22.5%, 60px);
    }
    h3 {
      font-size: clamp(1rem, 1.5vw, 1.25rem);
      font-weight: bold;
      padding-bottom: 0.5rem;
    }
    .maincopy {
      font-size: 0.8rem;
      color: $fontcolor_sub;
    }
  }
}
</style>
